import ZoneSelect from "./ZoneSelect";
import connector from "./connector";

export default connector(ZoneSelect);



// WEBPACK FOOTER //
// ./src/components/ZoneSelect/index.js